<div class="publication-card grid bg-grayscale-white mb-half">
    <div class="publication-card__image grid-12 grid-md-3">
        <img src="../../../assets/images/products/inmueble-test.png" alt="foto inmueble">
    </div>
    <div class="publication-card__description grid-12 grid-md-5">
        <h2 class="main-title d-flex ai-center text-base text-primary-base mt-none">ARPRO - Centro Internacional, Bogotá</h2>
        <p class="text-xsmall text-gray-scale-grayscale-black">Apartamento en venta</p>
        <div class="grid grid-gap-0">
            <div class="grid-7 grid-md-6">
                <span class="label-title text-primary-dark text-xsmall mt-small">Valor:</span>
                <h3 class="secondary-title text-half text-primary-dark mb-small mt-none">$573.000.000</h3>

                <span class="label-title text-grayscale-gray-5 text-xsmall">Código:</span>
                <h4 class="secondary-title m-none text-small">7060-15827839</h4>

                <p class="label-title text-grayscale-gray-5 text-xsmall mt-medium">Estado
                    <span class="secondary-title m-none text-small state-aceptar text-secondary-dark pl-xsmall pr-xsmall">Aceptado</span>
                </p> 
            </div>
            <div class="grid-5 grid-md-6">
                <span class="label-title text-primary-dark text-xsmall">Ärea:</span>
                <h4 class="secondary-title mt-none mb-mid pb-base text-half text-primary-dark ">77,38m2</h4>

                <p class="label-title text-grayscale-gray-5 text-xsmall p-relative">
                    <span class="icon-ofertas text-base text-secondary-dark text-bold p-absolute"></span>
                    Inmueble verificado</p>
            </div>
        </div>
    </div>
    <div class="grid-12 grid-md-4 text-center">
        <div class="border-offers pt-medium pb-half">
            <span class="label-title text-grayscale-gray-5 text-thumb">El valor de oferta fue de:</span>
            <h3 class="secondary-title m-none text-half text-grayscale-gray-6">$568’000.000</h3>
            <span class="label-title text-grayscale-gray-5 text-xsmall">El valor de oferta fue de:</span>
        </div>
        <div class="panel-footer mt-medium text-center">
            <button class="button secondary rounded text-xsmall px-mid py-tiny mr-base" type="button">Contraoferta</button>
        </div>
    </div>
</div>